import Vue from 'vue';
import ButtonLoaderMixin from '@/helpers/vue_mixins/ButtonLoaderMixin';
import OrdersExport from '@/plugins/graphql/mutations/v2/billing/orders-export.gql';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
export default Vue.extend({
    mixins: [AlertMixin, ButtonLoaderMixin],
    props: {
        billingUuid: {
            type: String,
            required: true,
        },
    },
    methods: {
        async onExport() {
            const self = this;
            self.requestOnFlight();
            await this.export()
                .then(() => {
                const msg = 'You have successfully exported the CSV file. Please wait for our email.';
                self.successNotification(msg);
            })
                .finally(() => {
                self.requestDone();
            });
        },
        async export() {
            return this.$apollo.mutate({
                mutation: OrdersExport,
                variables: {
                    input: {
                        billingUuid: this.billingUuid,
                    },
                },
            });
        },
    },
    render() {
        if (this.$scopedSlots.default) {
            const self = this;
            return this.$scopedSlots.default({
                isRequestOnProcess: self.isRequestOnProcess,
                onExport: self.onExport,
            });
        }
    },
});
